<template src="./Teaser.html"></template>
<style src="./Teaser.scss" lang="scss"></style>

<script>
	import Button from '@/components/Button/Button';
	import Icon from '@/components/Icon/Icon';

	export const CAPTION_COLORS = {
		default: '',
		error: 'error',
		accent: 'accent',
		webcent: 'webcent'
	};

	export const CAPTION_POSITION = {
		default: '',
		top: 'top'
	};

	export const CAPTION_SIZE = {
		default: '',
		big: 'big'
	};

	export const LABEL_COLORS = {
		default: '',
		error: 'error',
		accent: 'accent',
		webcent: 'webcent',
		grey: 'grey',
		greyLight: 'grey-light'
	};

	/**
	 * The Teaser Component commonly used for articles and Native Teaser ads.
	 * @vue-prop {Object} link The link to the endpoint for Teaser
	 * @vue-prop {string} link.href URL for the link
	 * @vue-prop {string} link.target Target window for the link
	 * @vue-prop {Object} [figure] The Image block of teaser with Image and in-image label
	 * @vue-prop {Object} [figure.img] The image of teaser
	 * @vue-prop {string} [figure.img.src] URL source for the image
	 * @vue-prop {string} [figure.img.alt] Alternative text for image in case of faulty url or screen reader
	 * @vue-prop {Object} [figure.caption] The in-image label
	 * @vue-prop {('' | 'top')} [figure.caption.position] The position of the in-image label
	 * @vue-prop {('' | 'big')} [figure.caption.size] The size of the in-image label
	 * @vue-prop {('' | 'error' | 'accent' | 'webcent')} [figure.caption.color] The color of the in-image label
	 * @vue-prop {string} [figure.caption.icon] The icon to be shown in in-image label
	 * @vue-prop {string} [figure.caption.text] The text to be shown in in-image label
	 * @vue-prop {Object} [article] The text block of the teaser
	 * @vue-prop {Object} [article.header] The header of the text block
	 * @vue-prop {string} [article.header.headline] The text of the header
	 * @vue-prop {('' | 'top')} [article.header.position] The position of the header
	 * @vue-prop {Object} [article.header.label] The label above the header
	 * @vue-prop {('' | 'accent' | 'error' | 'webcent' | 'grey' | 'grey-light')} [article.header.label.color] The color of the highlight in label
	 * @vue-prop {string} [article.header.label.highlight] The text of the highlight in label
	 * @vue-prop {string} [article.header.label.text] The text of the label
	 * @vue-prop {string} [article.summary] The running text of the teaser
	 * @vue-prop {string} [article.button] A button in the teaser. NOT USED!
	 * @vue-prop {string[]} [article.footer] An array of footer text blocks
	 * @vue-prop {('' | 'top' | 'left' | 'bottom' | 'right')} [separator] A small line at the given position
	 * @vue-prop {boolean} [articleoverlay] If the Teaser text should be on top of image block
	 */
	export default {
		name: 'HpTeaser',
		props: ['link', 'figure', 'article', 'separator', 'articleoverlay'],
		components: {
			'hp-button': Button,
			'hp-icon': Icon
		}
	};
</script>
